/**
 * Splits a loop's flat sub-step list into one group per iteration, using the
 * `iteration` tag the V2 executor writes on each child. Results recorded
 * without the tag (older runs, `if` children) come back as a single group.
 */
export function groupSubStepsByIteration<
  T extends { iteration?: number | null },
>(subSteps: T[]): T[][] {
  const groups: T[][] = [];
  let lastIteration: number | null | undefined;
  for (const step of subSteps) {
    const iteration = step.iteration ?? null;
    if (groups.length === 0 || iteration !== lastIteration) {
      groups.push([]);
      lastIteration = iteration;
    }
    groups[groups.length - 1].push(step);
  }
  return groups;
}
